import React, { useState } from "react";
import { useEffect } from "react";
import {FaBars, FaTimes, FaFacebookF, FaTwitter, FaInstagram} from "react-icons/fa";
import "./index.css"
import "../../Pages/LandingPage/HomePage/HomePage.css"
import { Link } from "react-router-dom";
import { ReactComponent as Nysc } from "../../Assets/LandingPage/Nysc-logo.svg";
const Footer = () => {
    return(
<footer>
    <div className="footer-box">
    <div className="top">
        <div className="top-logo-box">
        <Nysc />
        </div>
        <div className="top-getstarted-box">
        <h3>Ready to get started?</h3>
        <button>Get started</button>
        </div>
    </div>
    <div className="middle">
        <ul className="middle-box input-box">
        <li >Subscribe to our<br/>newsletter</li>
        <li className="email-list">
            <input type={"text"} placeholder={"Email address"}/>
            <input type={"button"} value={">"}/>
        </li> 
        </ul>
        <ul className="middle-box first-list">
        <li ><Link to ="/">Home</Link></li>
        <li ><Link to ="/about">About</Link></li>
        <li ><Link to ="/contactUs">Contact us</Link></li>
        <li ><Link to ="#">Sign up</Link></li>
        <li ><Link to ="/login">Login</Link></li>
        </ul>
        <ul className="middle-box second-list">
        <li ><Link to ="#">Help</Link></li>
        <li ><Link to ="#">NYSC Directorate Headquarters,<br/>Abuja, Nigeria.</Link></li>
        <li >+234-9035789012</li>
        </ul>
    </div>
    </div>
    <div className="bottom">
    <div className="bottom-details">
        <span className="bottom-text">
        <a href="#">Terms & Conditions</a>
        <a href="#">Privacy Policy</a>
        Developed by Sidmach Technologies
        </span>
        <div className="bottom-social-icons">
        <a href="#"><FaFacebookF /></a>  
        <a href="#"><FaTwitter /></a>
        <a href="#"><FaInstagram /></a>
        </div>
    </div>
    </div>
</footer>
    )
}
export default Footer;
